import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import itemsScheme from '../../../../../constants/scheme/itemsScheme';
import SectionsBuilder from '../../../../../shared/template-builder/SectionsBuilder';

function ItemsData(props) {
  return (
    <SectionsBuilder
      key="items"
      fieldArrayName="items"
      paneId="items"
      paneTitle={
        <FormattedMessage
          id="ui-plugin-inventory-templates.templateFields.items.builder.paneTitle"
          defaultMessage="Items Builder"
        />
      }
      defaultScheme={itemsScheme}
      initialValues={[]}
    />
  );
}

ItemsData.propTypes = {};

export default ItemsData;
